"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTEXT_MENU_CATEGORY_KEY = 'base';
exports.CONTEXT_MENU_COMPONENT_KEY = 'contextMenu';